import PageTitle from '@/components/core/PageTitle';
import { Outlet } from 'react-router';

const PathwayNavigatorLayout = () => {
  return (
    <div className="flex flex-col bg-canvas shadow-lg shadow-slate-200 rounded-t-lg size-11/12 h-full overflow-hidden">
      <PageTitle className="bg-primary text-primary-content" />
      <Outlet />
    </div>
  );
};

export default PathwayNavigatorLayout;
